var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "discard-changes", staticStyle: { height: "0" } },
    [
      _c(
        "div",
        {
          staticClass: "reveal",
          attrs: { id: "discardChangesModal", "data-reveal": "" },
        },
        [
          _c("div", { staticClass: "modal-container" }, [
            _c("p", { staticClass: "confirm-header" }, [
              _vm._v(_vm._s(_vm.$t("warn.discard"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row align-right nav_btn" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.closeAlertModal()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [{ name: "hkldreset", rawName: "v-hkldreset" }],
                staticClass: "btn btn--orange",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.discardChanges()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.ok")))]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }